import React from 'react';
import { useSelector } from 'react-redux';

import { useTranslation } from 'providers/GILT.provider';
import { selectOldFlagsHideMiniModal } from 'selectors/oldFlags.selectors';

export const NavTabs = ({ bookedByButton, history, selected, setType }) => {
  const { t } = useTranslation();
  const hideMiniModal = useSelector(selectOldFlagsHideMiniModal);

  return (
    <div>
      <ul className="tabs-menu">
        {history.location.pathname.indexOf('/timeoff') < 0 && (
          <div
            className={selected === 'booking' ? 'tab-item selected' : 'tab-item'}
            role="button"
            tabIndex={0}
            onClick={() => {
              const path = history.location.pathname
                .split('/')
                .filter((e) => e !== 'timeoff')
                .join('/');
              setType('booking');
              history.push(path);
            }}
          >
            {t('scheduler.booking.navTabs.newBooking')}
          </div>
        )}

        {!bookedByButton && (selected === 'timeOff' || hideMiniModal) && (
          <div
            style={{ cursor: 'default' }}
            className={selected === 'timeOff' ? 'tab-item selected' : 'tab-item'}
            role="button"
            tabIndex={0}
            onClick={() => {
              if (!hideMiniModal) return;
              history.push('timeoff');
              setType('timeoff');
            }}
          >
            {t('scheduler.booking.navTabs.timeOff')}
          </div>
        )}
      </ul>
    </div>
  );
};
